module.exports = __webpack_public_path__ + "assets/img/fanganweinzi01.2f8e1c5b.png";